import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { referralRoute } from '.'

const MyInvitation = lazyRouteComponent(
  () => import('../../../pages/profile/referral/my-invitation'),
)

export const myInvitationRoute = createRoute({
  getParentRoute: () => referralRoute,
  path: 'my-invitation',
  component: MyInvitation,
})
